import { render } from "./grocery_dashboard.vue?vue&type=template&id=30194d36"
import script from "./grocery_dashboard.vue?vue&type=script&lang=js"
export * from "./grocery_dashboard.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\grocery_board_admin_eticket\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__